import { ConfigService } from '@stockcare-services/config-service/config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PerformanceMetricService } from '@stockcare-services/performance-metric-service/performance-metric-service';
import { Observable } from 'rxjs';
import { AnalyticsNames } from '@stockcare-helpers/analytics-names';
import { ServicesStorageService } from '@stockcare-storage/service/service-storage.service';
import { IService } from '@stockcare-models/IService';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ServicesService {
  constructor(
    private http: HttpClient,
    private conf: ConfigService,
    private performanceMetricService: PerformanceMetricService,
    private serviceStorageService: ServicesStorageService
  ) {}

  getAll(institutionId: number, stockLocationId: number): Observable<IService[]> {
    const startTime = new Date();
    return new Observable((observer) => {
      this.http.get<IService[]>(`${this.conf.config.baseUrl}/service/stockLocation/${institutionId}/${stockLocationId}`).subscribe(
        (result) => {
          this.addUpdateLocalDatabase(result).then(() => {
            observer.next(result);
          });

          this.performanceMetricService.buildAndSubmitMetrics(startTime, AnalyticsNames.servicesListQuery);
        },
        (error) => observer.error(error)
      );
    });
  }

  private async addUpdateLocalDatabase(services: IService[]) {
    const mappedServices = this.serviceStorageService.map(services);
    await this.serviceStorageService.deleteAll();

    if (mappedServices && mappedServices.length > 0) {
      await this.serviceStorageService.addServices(mappedServices);
    }
  }
}
